/* import __COLOCATED_TEMPLATE__ from './user-api-keys.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();